export default "__VITE_ASSET__BRyHdfAI__"